import printReportListReducer from "./printReportListReducer";

const printReportListReducers = {
    printReportList: printReportListReducer
};

export default printReportListReducers;